import type { HealthRow } from '@/hooks/useHealthCheck';
import type { JSX } from 'react';

import { GenerateMissingTranslationRowButton } from './GenerateMissingTranslationRowButton';
import { RegenerateVoiceoverRowButton } from './RegenerateVoiceoverRowButton';

interface HealthRowActionsProps {
  row: HealthRow;
}

/**
 * Single dispatch point for the per-row action button rendered in health
 * lists. Picks the right button based on the row's issues:
 *
 *  - Row is missing a translation entirely → Generate translation
 *  - Row has any other content/voiceover gap → Sync voiceover
 *
 * Returns the matching component (or null when neither applies, e.g.
 * tour and tour-translation rows whose dialogs aren't wired yet).
 */
export function HealthRowActions({ row }: HealthRowActionsProps): JSX.Element | null {
  const isOnlyMissingTranslation =
    row.issues.length > 0 &&
    row.issues.every((issue) => issue.type === 'missing-translation');

  if (isOnlyMissingTranslation) {
    return <GenerateMissingTranslationRowButton row={row} />;
  }

  return <RegenerateVoiceoverRowButton row={row} />;
}
